import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../lib/auth";
import { toast } from "sonner";
import { Loader2, ShieldCheck } from "lucide-react";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setGoogleUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/login", { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(match[1]);

    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", {}, {
          headers: { "X-Session-ID": sessionId },
        });
        setGoogleUser(data.user);
        // clear hash and land on app
        window.history.replaceState(null, "", "/app");
        navigate("/app", { replace: true });
        toast.success(`Welcome, ${data.user.name || data.user.email}`);
      } catch (err) {
        toast.error("Google sign-in failed. Please try again.");
        navigate("/login", { replace: true });
      }
    })();
  }, [location.hash, navigate, setGoogleUser]);

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center" data-testid="auth-callback">
      <div className="text-center space-y-4">
        <div className="w-14 h-14 mx-auto rounded-xl bg-slate-900 flex items-center justify-center">
          <ShieldCheck className="w-7 h-7 text-sky-400" />
        </div>
        <div className="flex items-center justify-center gap-2 text-slate-700">
          <Loader2 className="w-4 h-4 animate-spin" /> Signing you in…
        </div>
      </div>
    </div>
  );
}
